import { FaroTextButton } from "@components/common/faro-text-button";
import { ArrowDownIcon, Menu, MenuItem } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { useRef, useState } from "react";
/**
 * DropdownButton renders a customizable button with a dropdown menu.
 *
 * It optionally displays a colored status indicator (a small circle) to the left of the label.
 * When clicked, it toggles a dropdown menu with the provided action items.
 */
export function DropdownButton({
  label,
  statusChipColor,
  actions
}) {
  const anchorRef = useRef(null);
  const [isOpenPopover, setIsOpenPopover] = useState(false);
  function handleMenuItemClick(action) {
    setIsOpenPopover(false);
    action.onClick();
  }
  return <Box ref={anchorRef}>
      <FaroTextButton onClick={() => setIsOpenPopover(!isOpenPopover)} sx={{
      display: "flex",
      gap: "0.5rem",
      padding: "0.5rem 1rem"
    }}>
        {statusChipColor && <Box sx={{
        height: "0.75rem",
        width: "0.75rem",
        background: statusChipColor,
        borderRadius: "50%"
      }} />}

        {label}
        <ArrowDownIcon sx={{
        fontSize: "21px",
        transform: isOpenPopover ? "rotate(-180deg)" : "none",
        transition: "transform 0.3s"
      }} />
      </FaroTextButton>

      <Menu open={isOpenPopover} anchorEl={anchorRef.current} onClose={() => setIsOpenPopover(false)} anchorOrigin={{
      vertical: "bottom",
      horizontal: "left"
    }} transformOrigin={{
      vertical: "top",
      horizontal: "left"
    }} minWidth={anchorRef.current?.offsetWidth ?? "auto"}>
        {actions.map((action_0, idx) => <MenuItem key={idx} label={action_0.label} onClick={() => handleMenuItemClick(action_0)} />)}
      </Menu>
    </Box>;
}